import { hotTopics } from "@/mocks/home";

export default function TopicWall() {
  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Topic Wall</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              标签话题墙
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              每个标签都汇集了同一角度的线索与讨论，点击即可顺着话题往下翻，不用在海量评论里逐条找。
            </p>
          </div>
          <span className="text-xs text-foreground-500">共 {hotTopics.length} 个热门标签 · 按讨论量排序</span>
        </div>

        <div className="mt-7 flex flex-wrap gap-2.5">
          {hotTopics.map((topic) => (
            <a
              key={topic.label}
              href="#latest"
              className={
                topic.hot
                  ? "flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
                  : "flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-800 cursor-pointer"
              }
            >
              {topic.hot && <i className="ri-fire-fill text-accent-400"></i>}
              <span>{topic.label}</span>
              <span
                className={
                  topic.hot
                    ? "rounded-full bg-background-50/25 px-1.5 text-[11px]"
                    : "rounded-full bg-background-300/70 px-1.5 text-[11px] text-foreground-600"
                }
              >
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}